import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { Plus, Minus } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onToggle
}: FAQItemProps) {
  return <div className="border-b border-gray-200 last:border-0" data-id="element-33">
      <button onClick={onToggle} className="w-full text-left py-5 flex items-start justify-between gap-4 focus:outline-none" data-id="element-34">
        <span className="font-bold text-text-main pr-4" data-id="element-35">{question}</span>
        <span className="shrink-0 mt-1 text-green-lime" data-id="element-36">
          {isOpen ? <Minus className="w-5 h-5" data-id="element-37" /> : <Plus className="w-5 h-5" data-id="element-38" />}
        </span>
      </button>
      <AnimatePresence data-id="element-39">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-40">
            <p className="pb-5 text-text-main/70 text-sm md:text-base leading-relaxed" data-id="element-41">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Necesito conocimientos de nutrición o medicina para aplicar esto?',
    a: "No. El protocolo está escrito en lenguaje de mamá, no de médica. Cada indicación tiene el 'por qué' explicado con claridad, pero el 'qué hacer' es concreto y simple."
  }, {
    q: '¿Funciona para todas las edades?',
    a: 'El protocolo cubre desde bebés en etapa de introducción alimentaria hasta niños en edad escolar. Cada receta y cada suplemento incluye indicaciones específicas por edad.'
  }, {
    q: '¿Reemplaza al pediatra?',
    a: 'No. Y el protocolo lo dice explícitamente. Lo que sí hace es darte herramientas para llegar al consultorio con información real y actuar con inteligencia entre consultas.'
  }, {
    q: '¿Cuánto tiempo por día requiere?',
    a: 'El desayuno inmune: 5 minutos. El caldo de huesos: 15 minutos de preparación + cocción lenta. El Protocolo SOS: lo aplicás cuando aparece el primer síntoma, no todos los días.'
  }, {
    q: '¿Funciona si mi hijo es muy selectivo con la comida?',
    a: "Específicamente para eso está el capítulo 'Cómo esconder los antibióticos naturales en comidas cotidianas.' El ajo va en los nuggets. El jengibre va en el smoothie. La cúrcuma da color al arroz. Ningún niño lo detecta."
  }, {
    q: '¿Y si ya le dieron muchos antibióticos?',
    a: 'Especialmente para eso existe el Protocolo de Reconstrucción Post-Antibiótico del Capítulo 9. El daño tiene solución. El proceso de reconstrucción activa es exactamente lo que encontrás ahí.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-42">
      <div className="max-w-3xl mx-auto" data-id="element-43">
        <FadeIn data-id="element-44">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-green-deep text-center mb-10" data-id="element-45">
            ❓ PREGUNTAS FRECUENTES
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-46">
          <div className="bg-cream rounded-2xl p-6 md:p-8" data-id="element-47">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} isOpen={openIndex === index} onToggle={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-48" />)}
          </div>
        </FadeIn>
      </div>
    </section>;
}